import RoleAssumption from './RoleAssumption/RoleAssumption';

const Activity = () => {
    return (
        <>
            <RoleAssumption />
        </>
    );
};

export default Activity;
